import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import { profile, yearsOfExperience } from "../../data/resume";

// Same list the footer uses, from src/data/resume.js.
const socials = [
  { href: profile.github, label: "GitHub", Icon: AiFillGithub },
  { href: profile.twitter, label: "Twitter", Icon: AiOutlineTwitter },
  { href: profile.linkedin, label: "LinkedIn", Icon: FaLinkedinIn },
  { href: profile.instagram, label: "Instagram", Icon: AiFillInstagram },
];

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              I have spent the last {yearsOfExperience()}+ years building web
              applications that real businesses run on — and I still enjoy it as
              much as the day I started. 🙂
              <br />
              <br />
              My day-to-day is
              <i>
                <b className="purple"> PHP, Laravel and CodeIgniter</b>
              </i>
              , with
              <i>
                <b className="purple"> MySQL</b>
              </i>
              &nbsp;underneath — schema design, query tuning and the kind of
              back-end work that has to keep running.
              <br />
              <br />
              My field of interest is building
              <i>
                <b className="purple"> new web products</b>
              </i>
              &nbsp;end to end: e-commerce platforms, ERP systems and SaaS
              billing tools.
              <br />
              <br />
              On the front end I work with
              <i>
                <b className="purple"> JavaScript, React.js and Bootstrap</b>
              </i>
              , and I am steadily picking up
              <i>
                <b className="purple"> Node.js and Next.js</b>
              </i>
              .
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              {socials.map(({ href, label, Icon }) => (
                <li className="social-icons" key={label}>
                  <a
                    href={href}
                    target="_blank"
                    rel="noreferrer"
                    aria-label={label}
                    className="icon-colour  home-social-icons"
                  >
                    <Icon />
                  </a>
                </li>
              ))}
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Home2;
